import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

const DEFAULT_MINI_APP_URL = '/tg-mini-app/'

export function buildMiniAppUrl(location) {
  const baseUrl = import.meta.env.VITE_TG_MINI_APP_URL || DEFAULT_MINI_APP_URL
  const miniAppPath = `${location.pathname.replace(/^\/tg-mini/, '') || '/'}${location.search}${location.hash}`
  if (/^https?:\/\//i.test(baseUrl)) {
    return new URL(miniAppPath, baseUrl).toString()
  }

  const normalizedBase = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl
  return `${normalizedBase}${miniAppPath}`
}

export function redirectToMiniApp(location, replace = (url) => window.location.replace(url)) {
  replace(buildMiniAppUrl(location))
}

function TelegramMiniAppBridge() {
  const location = useLocation()

  useEffect(() => {
    redirectToMiniApp(location)
  }, [location])

  return null
}

export default TelegramMiniAppBridge
